import { Component } from '@angular/core';

@Component({
  selector: 'app-group-main-view',
  templateUrl: './group-main-view.component.html',
  styleUrls: ['./group-main-view.component.scss'],
  standalone: false
})
export class GroupMainViewComponent { }
